import throttle from "lodash/throttle";
import { useEffect, useMemo, useRef, useState } from "react";
export function useEditorImageResize({ onResize, onRelease, }) {
    const leftHandleRef = useRef();
    const rightHandleRef = useRef();
    const [initialClientX, setInitialClientX] = useState();
    const [resizing, setResizing] = useState(null);
    const onResizeThrottled = useMemo(() => throttle(onResize, 50), [onResize]);
    useEffect(() => {
        // cancels "resizing" state when mouse is released
        // this needs to be at window level because we need to trigger regardless of mouse current target
        if (!resizing) {
            return;
        }
        const handleMouseUp = (event) => {
            setResizing(null);
            onRelease(resizing === "left"
                ? initialClientX - event.clientX
                : event.clientX - initialClientX);
        };
        window.addEventListener("mouseup", handleMouseUp);
        return () => {
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [resizing, initialClientX, onRelease]);
    useEffect(() => {
        // calls onResize callback when mouse is moved
        if (!resizing) {
            return;
        }
        const handleMouseMove = (event) => {
            onResizeThrottled(resizing === "left"
                ? initialClientX - event.clientX
                : event.clientX - initialClientX);
        };
        window.addEventListener("mousemove", handleMouseMove);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [resizing, initialClientX, onResizeThrottled]);
    useEffect(() => {
        // initializes "resizing" state when mouse is pressed over left or right handle
        const leftHandle = leftHandleRef.current;
        const rightHandle = rightHandleRef.current;
        if (!leftHandle || !rightHandle) {
            return;
        }
        const handleMouseDownLeft = (event) => {
            setInitialClientX(event.clientX);
            setResizing("left");
        };
        const handleMouseDownRight = (event) => {
            setInitialClientX(event.clientX);
            setResizing("right");
        };
        leftHandle.addEventListener("mousedown", handleMouseDownLeft);
        rightHandle.addEventListener("mousedown", handleMouseDownRight);
        return () => {
            leftHandle.removeEventListener("mousedown", handleMouseDownLeft);
            rightHandle.removeEventListener("mousedown", handleMouseDownRight);
        };
    }, []);
    return { leftHandleRef, rightHandleRef };
}
